import {Box,Switch,FormGroup,Tooltip,FormControlLabel} from '@mui/material';
import {evaluateReadOnly} from '../../../core/utilities/Utilities';

const FieldSwitch=({row,fieldName,application,recordRules,readOnly,setFieldValue})=>{
    const fieldProp=row?.[fieldName];
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const value=fieldProp?.value??false;
    return (
        <Box sx={{flex:1,minWidth:0}}>
            <FormGroup style={{paddingLeft:'10px',}}>
                <Tooltip 
                    placement="top"
                    title={fieldProp?.ui_tooltip?application.getLocale(row[fieldName]?.ui_tooltip):''}
                    disableHoverListener={!fieldProp?.ui_tooltip}>
                    <FormControlLabel control={
                        <Switch 
                            id={fieldName}
                            name={fieldName}
                            checked={value}
                            onChange={(event,newValue)=>{setFieldValue(fieldName,newValue);}}
                            disabled={readOnlyEvaluated}/>
                        } 
                        label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}/>
                </Tooltip>
            </FormGroup>
        </Box>
    );
}

export default FieldSwitch;
